module.exports = __webpack_public_path__ + "static/img/btn_satellite.7286349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_satellite.png
// module id = P6cV
// module chunks = 3